// extracted by mini-css-extract-plugin
export default {"grid":"MyProducts_grid__LZ45p","title":"MyProducts_title__B3OP2"};